import { customFieldsApi } from '@/features/customFields/api/customFieldsApi';
import type {
  CreateCustomFieldInput,
  CustomFieldDefinition,
  CustomFieldListFilter,
  UpdateCustomFieldInput,
} from '../types';

export const customFieldsService = {
  async listCustomFields(filters?: CustomFieldListFilter): Promise<CustomFieldDefinition[]> {
    return customFieldsApi.list(filters);
  },

  async getCustomField(id: string): Promise<CustomFieldDefinition> {
    return customFieldsApi.getById(id);
  },

  async createCustomField(data: CreateCustomFieldInput): Promise<CustomFieldDefinition> {
    return customFieldsApi.create(data);
  },

  async updateCustomField(
    id: string,
    data: UpdateCustomFieldInput,
  ): Promise<CustomFieldDefinition> {
    return customFieldsApi.update(id, data);
  },

  async deleteCustomField(id: string): Promise<void> {
    await customFieldsApi.remove(id);
  },

  async getFieldsByCategory(
    category: string,
    escritorioId?: string,
  ): Promise<CustomFieldDefinition[]> {
    return this.listCustomFields({
      category,
      escritorioId,
      active: true,
    });
  },
};
